import { createSlice } from '@reduxjs/toolkit';
import {
  enqueueSnackbar,
  closeSnackbar,
  removeSnackbar,
} from '../actions/notificationActions';

const appSlice = createSlice({
  name: 'app',
  initialState: {
    dataLoading: false,
    notifications: [],
  },
  reducers: {
    dataLoading: (state, action) => {
      state.dataLoading = action.payload;
    },
  },
  extraReducers: {
    [enqueueSnackbar]: (state, action) => {
      state.notifications.push({ key: action.payload.key, ...action.payload });
    },
    [closeSnackbar]: (state, action) => {
      state.notifications = state.notifications.map((notification) =>
        action.payload.dismissAll || notification.key === action.payload.key
          ? { ...notification, dismissed: true }
          : { ...notification }
      );
    },
    [removeSnackbar]: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.key !== action.payload.key
      );
    },
  },
});

export const { dataLoading } = appSlice.actions;
export default appSlice.reducer;
